import Vue from 'vue'
import moment from 'moment'
import axios from "axios";
import {CEP_GLOBAL} from "./urlConfig";
import {UTIL_SERVICE} from "./requestConfig";

Vue.filter('firstLastName', function (value) {
  if (value) {
    const stringSplit = value.split(" ");

    if (stringSplit.length >= 2) {
      return stringSplit[0].substring(0, 1) + stringSplit[1].substring(0, 1)
    } else {
      return stringSplit[0].substring(0, 2)
    }
  } else {
    return ''
  }
});

Vue.filter('dateFunil', function (value) {
  if (value) {
    let date = new Date();
    if (moment(String(value)).format('YYYY/MM/DD') === moment(String(date)).format('YYYY/MM/DD')) {
      return moment(String(value)).format('hh:mm')
    } else {
      return moment(String(value)).format('DD/MM/YYYY')
    }
  }
});

Vue.filter('limitTo', function (value, limit) {
  if (value) {
    return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
});

Vue.filter('countDays', function (value) {
  if (value) {
    const d1 = new Date(value);
    const d2 = new Date();

    return Math.round(((d2 - d1) / (1000 * 3600 * 24))).toFixed(0);
  }
});

Vue.filter('formatFullDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
});

Vue.filter('formatFullDate24', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
});

Vue.filter('formatHors', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm')
  }
});

Vue.filter('formatHors24', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
});

// filter to format with Z ending
Vue.filter('formatHors24Z', function (value) {
  if (value) {

    if (value[value.length - 1] === 'z') {
      return moment(String(value)).format('HH:mm')
    }

    return moment(String(value + 'z')).format('HH:mm')
  }
});

Vue.filter('formatFullDateS', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
});

Vue.filter('hourFormatHHmm', function (value) {
  if (value) {
    try {
      return moment.utc(value).format('HH:mm:ss')
    } catch (e) {
      return value
    }
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    try {
      return moment(String(value)).format('DD/MM/YYYY')
    } catch (e) {
      return value
    }
  }
});

Vue.filter('formatDateDefault', function (value) {
  if (value) {

    const dateSplited = value.split('T')[0]

    try {
      return moment(String(dateSplited)).format('DD/MM/YYYY')
    } catch (e) {
      return value
    }
  }
});

Vue.filter('cpfOrCnpj', (string) => {
  if (string) {
    let stringRegex = string.replace(/[^0-9]/g, "");
    switch (stringRegex.length) {
      case 11:
        return stringRegex.substring(0, 3) + "." + stringRegex.substring(3, 6) + "." + stringRegex.substring(6, 9) + "-" + stringRegex.substring(9, 11);
      case 14:
        return stringRegex.substring(0, 2) + "." + stringRegex.substring(2, 5) + "." + stringRegex.substring(5, 8) + "/" + stringRegex.substring(8, 12) + "-" + stringRegex.substring(12, 14);
      default:
        return string;
    }
  }
});

Vue.filter('formatPhone', function (phone) {
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});

Vue.filter('formatMoneyReal', function (value) {
  if (value) {
    try {
      return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    } catch (e) {
      return value
    }
  }
});



// WEBPACK FOOTER //
// ./src/filters.js